import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import * as fromRoutes from "../actions/types";
import { useRouter, canViewStaffDirectory } from "utils";
import { INFO_HOME_ROUTE } from "features/home/home-routes";

import StaffList from "./staff-list-container";
import Summary from "./summary-container";
import Staff from "./staff-container";

const StaffRoutes = ({ onGetStaffList, onSearchClear, role, supervisingStaffList }) => {
	const canViewDirectory = canViewStaffDirectory(role, supervisingStaffList);

	useEffect(() => {
		if (!canViewDirectory) {
			return;
		}
		onSearchClear();
		onGetStaffList();
	}, [onGetStaffList, onSearchClear, canViewDirectory]);

	if (!canViewDirectory) {
		return <Redirect to={INFO_HOME_ROUTE} />;
	}

	return (
		<Switch>
			<Route exact path={fromRoutes.STAFF_ROUTE} component={StaffList} />
			<Route path={fromRoutes.STAFF_MEMBER_TAB_ROUTE} component={Staff} />
		</Switch>
	);
};

StaffRoutes.propTypes = {
	onGetStaffList: PropTypes.func.isRequired,
	onSearchClear: PropTypes.func.isRequired,
	role: PropTypes.string,
	supervisingStaffList: PropTypes.array,
};

/**
 * Staff detail is a single page (summary + embedded sections). Legacy URLs such as
 * /staff/:id/notes, /staff/:id/summary, or /staff/:id/training redirect to /staff/:id.
 */
export const ChildRoutes = ({ onAddPhotoNote }) => {
	const { match, location } = useRouter();
	const staffId = match && match.params && match.params.staffId;
	const base = `${fromRoutes.STAFF_PATH}/${staffId}`;
	const pathname = (location && location.pathname) || "";
	const normalized = pathname.replace(/\/+$/, "");
	const normalizedBase = base.replace(/\/+$/, "");
	if (
		staffId &&
		normalized !== normalizedBase &&
		normalized.startsWith(`${normalizedBase}/`)
	) {
		return <Redirect to={base} />;
	}
	return <Summary onAddPhotoNote={onAddPhotoNote} />;
};

ChildRoutes.propTypes = {
	onAddPhotoNote: PropTypes.func,
};

export default StaffRoutes;
